import { apiSlice } from "../../../_api/apiSlice";

export const roleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRole: builder.mutation({
      query: (data) => ({
        url: "/role/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Roles"],
    }),
    getAllRoles: builder.query({
      query: (params) => ({
        url: "/role/",
        method: "GET",
        params,
      }),
      providesTags: ["Roles"],
    }),
    getRoleById: builder.query({
      query: (id) => ({
        url: `/role/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Role", id }],
    }),
    updateRole: builder.mutation({
      query: (data) => ({
        url: `/role/${data._id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { _id }) => [
        "Roles",
        { type: "Role", id: _id },
      ],
    }),
    // `reassignToRoleId` is optional - omitted on the first attempt, the
    // backend responds 409 (with how many users are affected) instead of
    // deleting if the role still has holders. The caller re-invokes with a
    // chosen replacement role's id to actually delete - see RolesPage's
    // delete-confirmation flow.
    deleteRole: builder.mutation({
      query: ({ id, reassignToRoleId } = {}) => ({
        url: `/role/${id}`,
        method: "DELETE",
        body: reassignToRoleId ? { reassignToRoleId } : undefined,
      }),
      invalidatesTags: ["Roles"],
    }),
  }),
});

export const {
  useCreateRoleMutation,
  useGetAllRolesQuery,
  useGetRoleByIdQuery,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = roleApiSlice; 